import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import {
  Lightbulb, Lightning, Timer, TrendUp, Sparkle, X,
} from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NUDGE_ICONS = {
  welcome: Lightbulb,
  streak: Lightning,
  pattern: TrendUp,
  recommendation: Timer,
  insight: Sparkle,
  ai_insight: Sparkle,
};

const NUDGE_COLORS = {
  high: "#E76F51",
  medium: "#F4A261",
  low: "#84A98C",
};

export default function SmartNudges() {
  const [nudges, setNudges] = useState([]);
  const [dismissed, setDismissed] = useState(new Set());

  useEffect(() => {
    axios.get(`${API}/nudges`, { withCredentials: true })
      .then((res) => setNudges(res.data))
      .catch(() => {});
  }, []);

  const dismiss = (i) => setDismissed((prev) => new Set([...prev, i]));
  const visible = nudges.filter((_, i) => !dismissed.has(i));

  if (visible.length === 0) return null;

  return (
    <div className="mb-6 space-y-2" data-testid="smart-nudges">
      <AnimatePresence>
        {nudges.map((nudge, i) => {
          if (dismissed.has(i)) return null;
          const Icon = NUDGE_ICONS[nudge.type] || Lightbulb;
          const color = NUDGE_COLORS[nudge.priority] || "#84A98C";

          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, x: 20, height: 0 }}
              transition={{ delay: i * 0.1 }}
              className="rounded-2xl p-3.5 flex items-start gap-3 border"
              style={{ borderColor: color + "25", backgroundColor: color + "08" }}
              data-testid={`nudge-${nudge.type}-${i}`}
            >
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5"
                style={{ backgroundColor: color + "18" }}
              >
                <Icon size={15} weight="duotone" style={{ color }} />
              </div>
              <p className="flex-1 text-sm text-[#1A2421] leading-relaxed">{nudge.message}</p>
              <button
                onClick={() => dismiss(i)}
                className="shrink-0 p-1 text-[#78857F] hover:text-[#1A2421] transition-colors"
                data-testid={`dismiss-nudge-${i}`}
              >
                <X size={14} />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
